// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f0Bm3JnewIanFGW9jKko{position:relative}`, "",{"version":3,"sources":["webpack://./src/features/dashboard/views/DashboardView/components/DashboardLink/component.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA","sourcesContent":[".link {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `f0Bm3JnewIanFGW9jKko`
};
export default ___CSS_LOADER_EXPORT___;
